import { spacing } from '@mehilainen/mds-tokens';
import { baseTypography } from '@mehilainen/mds-tokens/typography';
import { buttonClasses, circularProgressClasses } from '@mui/material';
const loadingIconSize = {
    sizeSmall: spacing[500].px,
    sizeMedium: spacing[600].px,
    sizeLarge: spacing[700].px,
};
export const getButtonSizeStyle = (size, tokens) => ({
    fontSize: tokens.uiElementButton[size].fontSize,
    fontWeight: baseTypography.weight.Medium,
    lineHeight: baseTypography.height.Small,
    height: tokens.uiElementButton[size].height,
    gap: tokens.uiElementButton[size].gap,
    padding: `0 ${tokens.uiElementButton[size].padding}`,
    // !important for overriding the inline CSS styling for span element with class MuiCircularProgress-root
    [`&.${buttonClasses.loadingPositionCenter} .${buttonClasses.loadingIndicator} .${circularProgressClasses.root}`]: {
        height: `${loadingIconSize[size]} !important`,
        width: `${loadingIconSize[size]} !important`,
    },
    // change button's padding if button has child with class 'MuiButton-startIcon' or 'MuiButton-endIcon'
    [`&:has( > .${buttonClasses.startIcon})`]: {
        paddingLeft: tokens.uiElementButton[size].paddingForIcon,
    },
    [`&:has( > .${buttonClasses.endIcon})`]: {
        paddingRight: tokens.uiElementButton[size].paddingForIcon,
    },
});
